import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/apps/loyalty/app/[hostname]/(auth)/layout.tsx");
